/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Phone_Is_User_Allowed_To_Toggle_MicInputs */

const en_forms_templates_settings_phone_is_user_allowed_to_toggle_mic = /** @type {(inputs: Forms_Templates_Settings_Phone_Is_User_Allowed_To_Toggle_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mic`)
};

const de_forms_templates_settings_phone_is_user_allowed_to_toggle_mic = /** @type {(inputs: Forms_Templates_Settings_Phone_Is_User_Allowed_To_Toggle_MicInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mic`)
};

/**
* | output |
* | --- |
* | "Mic" |
*
* @param {Forms_Templates_Settings_Phone_Is_User_Allowed_To_Toggle_MicInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_phone_is_user_allowed_to_toggle_mic = /** @type {((inputs?: Forms_Templates_Settings_Phone_Is_User_Allowed_To_Toggle_MicInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Phone_Is_User_Allowed_To_Toggle_MicInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_phone_is_user_allowed_to_toggle_mic(inputs)
	return de_forms_templates_settings_phone_is_user_allowed_to_toggle_mic(inputs)
});